/**
 * Automy.Core.Enums.Reporting.Queries.ReportingQueryPredicateKind
 * Optional on the wire. Converter uses shape (field vs items).
 */
export default Object.freeze({
  Comparison: 'comparison',
  Group: 'group',
});
